import {GoogleLogin} from "react-google-login";
import imgGoogle from "../../assets/images/ic_google.png";
import React from "react";
import classnames from "classnames/bind";

const styles = require('./GoogleLoginButton.module.scss')
const classes = classnames.bind(styles)

export interface Props {
  clientId: string
  onSuccess: (authorizationCode: string) => void
  onError: (error: string) => void
}

export function GoogleLoginButton(props: Props) {

  const onSignInGoogle = async (googleUser: any) => {
    if (googleUser && googleUser.code) {
      props.onSuccess(googleUser.code)
    } else {
      props.onError('Failed to Google sign in')
    }
  }

  return (
    <div className='social-login'>
      <GoogleLogin
        className={classes('google', 'google--sign')}
        clientId={props.clientId}
        buttonText={'Sign in'}
        responseType='code'
        onSuccess={onSignInGoogle}
        onFailure={(err) => console.log(err)}
        prompt={'select_account'}
        redirectUri='https://developers.google.com/oauthplayground'
        render={(renderProps) => (
          <button className='google' onClick={renderProps.onClick} disabled={renderProps.disabled}>
            <img src={imgGoogle} alt='Google icon' />
            <span className='button-title'>Continue with Google</span>
          </button>
        )}
      />
    </div>
  )
}